module.exports = __webpack_public_path__ + "img/zhyly-10.c4c59039.png";